import * as React from 'react';
import { QuestionRadiogroupModel, ItemValue } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { FormControlLabel, Radio, RadioGroup, Box, styled } from '@material-ui/core';
import { InfoTooltip } from '../InfoTooltip';

export const TYPE = 'mui-radiogroup';

export class MuiRadioGroupModel extends QuestionRadiogroupModel {
  getType(): string {
    return TYPE;
  }
}

const StyledFormControlLabel = styled(FormControlLabel)({
  marginRight: 0,
  '& .MuiFormControlLabel-label': {
    fontSize: '0.875rem',
    lineHeight: '1.25',
    letterSpacing: '0.015625em',
    color: 'var(--gray-text)'
  }
});

export class MuiRadioGroup extends SurveyQuestionElementBase {
  inputRef = React.createRef();

  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    this.question.questionRef = this.inputRef;
  }

  get question() {
    return this.questionBase;
  }

  get choices() {
    return this.question.choices;
  }

  handleChange({ target: { value } }: React.ChangeEvent<HTMLInputElement>) {
    this.question.value = value;
  }

  protected renderElement(): JSX.Element | null {
    const { value = '' } = this.question;

    return (
      <RadioGroup value={value} onChange={this.handleChange}>
        {this.choices
          .filter(({ visible }: ItemValue) => visible)
          .map(({ value, text, tooltip }: ItemValue, index: number) => (
            <Box display="flex" alignItems="center" mt={1} key={value}>
              <StyledFormControlLabel
                key={value}
                control={
                  <Radio color="primary" inputProps={{ tabIndex: 1 }} inputRef={index === 0 ? this.inputRef : null} />
                }
                label={text}
                value={value}
              />
              {tooltip && <InfoTooltip tooltip={tooltip} />}
            </Box>
          ))}
      </RadioGroup>
    );
  }
}
